<template>
  <div class="template-edit-page">
    <div class="edit-page">
      <div class="pull-left clear-fix">
        <a href="javascript:;" :class="{'active': activeTab == 0}" @click="handleEditTab">编辑模板</a>
      </div>
      <div class="pull-right clear-fix">
        <!-- <a
          href="javascript:;"
          @click="handleTextEditing"
        >
          <i class="el-icon-edit"></i>
          {{textEditButton}}
        </a>-->
        <a href="javascript:;" @click="openPreview">
          <i class="el-icon-view"></i>预览
        </a>
        <el-button class="finished-btn" type="primary" plain @click="handleFinishedSurvey">完成</el-button>
      </div>
    </div>
    <div v-if="!showAnalysis && !textEdit" class="edit-main clear-fix">
      <div class="edit-sidebar" style="position: relative;">
        <el-tabs type="border-card" :value="sidebarActive" @tab-click="handleSidebarChange">
          <el-tab-pane label="题目控件" name="0">
            <div class="widget-item" @click="handleAddRadio">
              <i class="wj-icon radio-icon widget-icon"></i>
              <span>单选题</span>
            </div>
            <div class="widget-item" @click="handleAddCheckbox">
              <i class="wj-icon checkbox-icon widget-icon"></i>
              <span>多选题</span>
            </div>
            <div class="widget-item" @click="handleAddStar">
              <i class="wj-icon star-icon widget-icon"></i>
              <span>打分题</span>
            </div>
            <div class="widget-item" @click="handleAddTextarea">
              <i class="wj-icon textarea-icon widget-icon"></i>
              <span>文本题</span>
            </div>
            <div class="widget-item" @click="handleAddMatrixRadio">
              <i class="wj-icon matrixRadio-icon widget-icon"></i>
              <span>矩阵单选题</span>
            </div>
            <div class="widget-item" @click="handleAddMatrixCheckbox">
              <i class="wj-icon matrixCheckbox-icon widget-icon"></i>
              <span>矩阵多选题</span>
            </div>
            <div class="widget-item" @click="handleAddSelect">
              <i class="wj-icon select-icon widget-icon"></i>
              <span>下拉题</span>
            </div>
            <div class="widget-item" @click="handleAddDate">
              <i class="wj-icon date-icon widget-icon"></i>
              <span>日期题</span>
            </div>
            <div class="widget-item" @click="handleAddRegion">
              <i class="wj-icon region-icon widget-icon"></i>
              <span>区域题</span>
            </div>
            <div class="widget-item" @click="handleAddMatrixStar">
              <i class="wj-icon matrixStar-icon widget-icon"></i>
              <span>矩阵打分题</span>
            </div>
            <div class="widget-item" @click="handleAddSort">
              <i class="wj-icon sort-icon widget-icon"></i>
              <span>排序题</span>
            </div>
            <div class="widget-item" @click="handleAddTextMultiple">
              <i class="wj-icon textMultiple-icon widget-icon"></i>
              <span>填空题</span>
            </div>
            <div class="widget-item" @click="handleAddDiscription">
              <i class="wj-icon description-icon widget-icon"></i>
              <span>段落说明</span>
            </div>
            <div class="widget-item" @click="handleAddUpload">
              <i class="wj-icon upload-icon widget-icon"></i>
              <span>附件题</span>
            </div>

            <div class="widget-item" @click="handleAddChainedSelects">
              <i class="wj-icon chainedSelects-icon widget-icon"></i>
              <span>联动题</span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="问卷大纲" name="1">
            <div v-for="(page, index) in survey.pages" :key="index" class="outline-item">
              <p class="outline-title">第{{ index + 1 }}页</p>
              <ul>
                <draggable
                  style="min-height: 20px"
                  v-model="page.questions"
                  :options="{group:'people'}"
                  @start="drag=true"
                  @end="handleDragEnd"
                >
                  <li
                    class="ques-item"
                    v-for="ques in page.questions"
                    :key="ques.id"
                    @click="handleJumpToQue(index, ques, page)"
                  >
                    <i :class="['wj-icon', ques.type + '-icon']"></i>
                    <p
                      class="question-content"
                    >{{ ques.type !== 'description' ? (ques.index + 1) + '.' : '' }}{{ removeLables(ques.title) }}</p>
                  </li>
                </draggable>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="收藏题库" name="2">
            <el-collapse
              class="collect-page"
              v-model="activeBank"
              accordion
              @change="handleCollapse"
            >
              <el-collapse-item title="常用题库" name="2">
                <template slot="title">
                  <span>
                    <i class="wj-collect-icon wj-sys-icon"></i>常用题库
                  </span>
                </template>
                <ul class="bank-list">
                  <li v-for="(ques, i) in commonQuesArr" :key="i">
                    <p
                      class="bank-title"
                      @click="handleClickBankItem(ques.questionContent)"
                    >{{ removeLables(ques.questionContent.title) }}</p>
                    <el-popover popper-class="bank-detail" placement="bottom" trigger="hover">
                      <p class="bank-detail-title">
                        <span>{{ removeLables(ques.questionContent.title) }}</span>
                        <span>[{{ quesTypeMap[ques.questionContent.type] }}]</span>
                      </p>
                      <ul
                        v-if="ques.questionContent.options && ques.questionContent.options.length > 0"
                      >
                        <li
                          :class="{'bank-detail-opt': true, 'inline': ques.questionContent.subTitles}"
                          v-for="(opt, i) in ques.questionContent.options"
                          :key="i"
                        >{{opt.text}}</li>
                      </ul>
                      <p
                        v-if="ques.questionContent.starNum"
                      >{{ques.questionContent.starBeginNum}} ~ {{ques.questionContent.starBeginNum + ques.questionContent.starNum - 1}}</p>
                      <ul
                        v-if="ques.questionContent.subTitles && ques.questionContent.subTitles.length > 0"
                      >
                        <li v-for="(subTitle, i) in ques.questionContent.subTitles" :key="i">
                          <p class="bank-detail-opt">{{subTitle.text}}</p>
                        </li>
                      </ul>
                      <i slot="reference" class="el-icon-view"></i>
                    </el-popover>
                  </li>
                </ul>
              </el-collapse-item>
              <el-collapse-item v-for="item in collectList" :name="item.dirId" :key="item.dirId">
                <template slot="title">
                  <span v-if="!item.isRenameDir">
                    <i
                      class="wj-collect-icon wj-file-icon"
                      :class="{'wj-like-icon':item.dirId == 0}"
                    ></i>
                    {{item.dirName}}
                  </span>
                  <el-input
                    v-else
                    :class="'newDirNameInput-' + item.dirId"
                    class="dir-name-input"
                    style="width: 120px;"
                    v-model="item.newDirName"
                    @keyup.stop.enter="handleBlurRenameDir(item)"
                    @blur="handleBlurRenameDir(item)"
                  ></el-input>
                  <el-tooltip placement="right" effect="light" class="el-tooltip-icon">
                    <div slot="content">
                      <a
                        href="javascript:;"
                        class="content-info"
                        @click.stop="handleRenameDir(item)"
                      >重命名</a>
                      <br />
                      <br />
                      <a
                        href="javascript:;"
                        class="content-info"
                        @click.stop="handleDeleteDir(item)"
                      >删除</a>
                    </div>
                    <a href="javascript:;" v-if="item.dirId != 0" class="tooltip-icon">
                      <i>...</i>
                    </a>
                  </el-tooltip>
                </template>
                <like-animate v-if="showLikeHeart"></like-animate>
                <p class="no-bank-tips" v-if="bankArr.length == 0">暂无收藏</p>
                <ul v-else class="bank-list">
                  <li v-for="(ques, i) in bankArr" :key="i">
                    <p
                      class="bank-title"
                      @click="handleClickBankItem(ques.questionContent)"
                    >{{ removeLables(ques.questionContent.title) }}</p>
                    <el-popover popper-class="bank-operate" placement="right" trigger="hover">
                      <div>
                        <el-button type="text" @click="handleDelBankItem(ques.id)">删除</el-button>
                      </div>
                      <i slot="reference" class="el-icon-edit"></i>
                    </el-popover>
                    <el-popover popper-class="bank-detail" placement="bottom" trigger="hover">
                      <p class="bank-detail-title">
                        <span>{{ removeLables(ques.questionContent.title) }}</span>
                        <span>[{{ quesTypeMap[ques.questionContent.type] }}]</span>
                      </p>
                      <ul
                        v-if="ques.questionContent.options && ques.questionContent.options.length > 0"
                      >
                        <li
                          :class="{'bank-detail-opt': true, 'inline': ques.questionContent.subTitles}"
                          v-for="(opt, i) in ques.questionContent.options"
                          :key="i"
                        >{{removeLables(opt.text)}}</li>
                      </ul>
                      <p
                        v-if="ques.questionContent.starNum"
                      >{{ques.questionContent.starBeginNum}} ~ {{ques.questionContent.starBeginNum + ques.questionContent.starNum - 1}}</p>
                      <ul
                        v-if="ques.questionContent.subTitles && ques.questionContent.subTitles.length > 0"
                      >
                        <li v-for="(subTitle, i) in ques.questionContent.subTitles" :key="i">
                          <p class="bank-detail-opt">{{subTitle.text}}</p>
                        </li>
                      </ul>
                      <i slot="reference" class="el-icon-view"></i>
                    </el-popover>
                  </li>
                </ul>
                <div class="pager-center">
                  <el-pagination
                    v-if="collectTotal > 15"
                    @current-change="getCollection"
                    :current-page.sync="collectPage"
                    :page-size="15"
                    layout="total, prev, pager, next"
                    :total="collectTotal"
                  ></el-pagination>
                </div>
              </el-collapse-item>
              <a
                href="javascript:;"
                class="collapse-add-collect"
                @click="collectDirDialogShow = true"
              >
                <span>+</span>添加收藏夹
              </a>
            </el-collapse>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="edit-part">
        <el-tabs v-model="activePage" type="card" :editable="canEdit" @edit="handleTabsEdit">
          <el-tab-pane
            :key="item.index"
            v-for="(item, idx) in survey.pages"
            :label="'第' + (idx + 1) + '页'"
            :name="idx + 1 + ''"
          >
            <div class="edit-title" v-if="idx == 0">
              <quill-editor
                v-model="survey.title"
                @blur="handleBlurQuill($event, handleSaveTitle)"
                @focus="handleFocusQuill($event)"
                @click="handleClickQuill($event)"
                :options="baseConfig"
              ></quill-editor>
            </div>
            <div class="edit-subtitle" v-if="idx == 0">
              <quill-editor
                v-model="survey.prefix"
                @blur="handleBlurQuill($event, handleSaveSurvey)"
                @focus="handleFocusQuill($event)"
                :options="baseConfig"
              ></quill-editor>
            </div>
            <draggable
              v-model="item.questions"
              :options="{group:'people', disabled: cannotDrag,sort:canEdit}"
              @start="drag=true"
              @end="handleDragEnd"
            >
            <template  v-if="item.questions.length > 0">
              <div
                v-for="(ques, index) in item.questions"
                :key="index"
              >
                <el-form
                  v-if="focusQues === ques.id"
                  ref="form"
                  :model="tempQuesData"
                  :rules="editRule"
                  label-width="80px"
                  class="question-editor"
                >
                  <el-form-item class="typeChanger" v-if="tempQuesData.type != 'description'">
                    <el-select v-model="tempQuesData.type" @change="handleQuestionType">
                      <el-option
                        v-for="(item, index) in questionsTypeOption"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-checkbox class="requiredCheck" v-model="tempQuesData.required">必填</el-checkbox>
                  </el-form-item>
                  <div v-if="tempQuesData.type == 'checkbox'">
                    <checkbox
                      :tempQuesData="tempQuesData"
                      :isEditing="true"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      :survey="survey"
                      :config="config"
                      @addOtherCheckbox="handleAddOtherCheckbox"
                      @batchChange="handleBatchChange"
                      @addCheckboxOpt="addCheckboxOpt"
                    ></checkbox>
                  </div>
                  <div v-if="tempQuesData.type == 'radio'">
                    <radio
                      :tempQuesData="tempQuesData"
                      :isEditing="true"
                      :survey="survey"
                      :config="config"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      @addOtherRadio="handleAddOtherRadio"
                      @batchChange="handleBatchChange"
                      @addRadioOpt="addRadioOpt"
                    ></radio>
                  </div>
                  <div v-if="tempQuesData.type == 'textarea'">
                    <text-area :config="config" :tempQuesData="tempQuesData" :isEditing="true"></text-area>
                  </div>
                  <div v-if="tempQuesData.type == 'star'">
                    <star :config="config" :tempQuesData="tempQuesData" :isEditing="true"></star>
                  </div>
                  <div v-if="tempQuesData.type == 'matrixRadio'">
                    <matrix-radio
                      :isEditing="true"
                      :tempQuesData="tempQuesData"
                      :survey="survey"
                      :config="config"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      @batchChange="handleBatchChange"
                    ></matrix-radio>
                  </div>
                  <div v-if="tempQuesData.type == 'matrixCheckbox'">
                    <matrix-checkbox
                      :isEditing="true"
                      :config="config"
                      :tempQuesData="tempQuesData"
                      :survey="survey"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      @batchChange="handleBatchChange"
                    ></matrix-checkbox>
                  </div>
                  <div v-if="tempQuesData.type == 'matrixStar'">
                    <matrix-star
                      :isEditing="true"
                      :config="config"
                      :tempQuesData="tempQuesData"
                      :survey="survey"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      @batchChange="handleBatchChange"
                    ></matrix-star>
                  </div>
                  <div v-if="tempQuesData.type == 'select'">
                    <wqselect
                      :isEditing="true"
                      :config="config"
                      @addOtherselect="handleAddOtherselect"
                      @batchChange="handleBatchChange"
                      :tempQuesData="tempQuesData"
                      :survey="survey"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      @addselectOpt="handleAddSelectOpt"
                    ></wqselect>
                  </div>
                  <div v-if="tempQuesData.type == 'sort'">
                    <sort
                      :isEditing="true"
                      :config="config"
                      @batchChange="handleBatchChange"
                      @addSortOpt="handleAddSortOpt"
                      :tempQuesData="tempQuesData"
                      :checkboxs="getCheckboxs(tempQuesData.realIndex)"
                      :survey="survey"
                    ></sort>
                  </div>
                  <div v-if="tempQuesData.type == 'description'">
                    <description :isEditing="true" :config="config" :tempQuesData="tempQuesData"></description>
                  </div>
                  <div v-if="tempQuesData.type == 'upload'">
                    <upload :isEditing="true" :config="config" :tempQuesData="tempQuesData"></upload>
                  </div>
                  <div v-if="tempQuesData.type == 'chainedSelects'">
                    <chained-selects
                      :config="config"
                      :isEditing="true"
                      :tempQuesData="tempQuesData"
                    ></chained-selects>
                  </div>
                  <div v-if="tempQuesData.type == 'textMultiple'">
                    <text-multiple :isEditing="true" :tempQuesData="tempQuesData" :config="config"></text-multiple>
                  </div>
                  <div v-if="tempQuesData.type == 'date'">
                    <date :isEditing="true" :tempQuesData="tempQuesData" :config="config"></date>
                  </div>
                  <div v-if="tempQuesData.type == 'region'">
                    <region :isEditing="true" :tempQuesData="tempQuesData" :config="config"></region>
                  </div>
                  <div class="edit-btns">
                    <el-button type="primary" @click="handleConfirm($event, ques)">确 定</el-button>
                    <el-button @click="handleCancel($event)">取 消</el-button>
                  </div>
                </el-form>
                <el-form v-else :model="ques" label-width="80px" class="question-viewer">
                  <div>
                    <div v-if="ques.type == 'radio'">
                      <radioNew
                        :survey="survey"
                        :ques="ques"
                        :activePage="activePage"
                        :isEditing="false"
                        :item="item"
                      ></radioNew>
                    </div>
                    <div v-if="ques.type == 'checkbox'">
                      <checkboxNew :survey="survey" :ques="ques" :isEditing="false"></checkboxNew>
                    </div>
                    <div v-if="ques.type == 'textarea'">
                      <text-area :ques="ques" :isEditing="false"></text-area>
                    </div>
                    <div v-if="ques.type == 'star'">
                      <star :ques="ques" :starEntityList="ques.starEntityList" :isEditing="false"></star>
                    </div>
                    <div v-if="ques.type == 'matrixRadio'">
                      <matrix-radio :isEditing="false" :ques="ques"></matrix-radio>
                    </div>
                    <div v-if="ques.type == 'matrixCheckbox'">
                      <matrix-checkbox :isEditing="false" :ques="ques"></matrix-checkbox>
                    </div>
                    <div v-if="ques.type == 'matrixStar'">
                      <matrix-star :isEditing="false" :ques="ques"></matrix-star>
                    </div>
                    <div v-if="ques.type == 'select'">
                      <wqselect :ques="ques" :isEditing="false"></wqselect>
                    </div>
                    <div v-if="ques.type == 'sort'">
                      <sort :ques="ques" :isEditing="false"></sort>
                    </div>
                    <div v-if="ques.type == 'description'">
                      <description :ques="ques" :isEditing="false"></description>
                    </div>
                    <div v-if="ques.type == 'upload'">
                      <upload :ques="ques" :isEditing="false"></upload>
                    </div>
                    <div v-if="ques.type == 'chainedSelects'">
                      <chained-selects :ques="ques" :isEditing="false"></chained-selects>
                    </div>
                    <div v-if="ques.type == 'textMultiple'">
                      <text-multiple :ques="ques" :isEditing="false"></text-multiple>
                    </div>
                    <div v-if="ques.type == 'date'">
                      <date :ques="ques" :isEditing="false"></date>
                    </div>
                    <div v-if="ques.type == 'region'">
                      <region :ques="ques" :isEditing="false"></region>
                    </div>
                  </div>
                  <div class="ques-cover" v-if="canEdit" @click="handleFocus($event, ques)">
                    <div class="cover-box">
                      <ul class="cover-tools">
                        <li @click.stop="handleFocus($event, ques)">编辑</li>
                        <li @click.stop="handleCopy($event, ques, index)">复制</li>
                        <li @click.stop="handleLink(ques)">跳转</li>
                        <li @click.stop="handleCollect(ques)">收藏</li>
                        <li @click.stop="handleDelete(ques, index)">删除</li>
                      </ul>
                    </div>
                  </div>
                </el-form>
              </div>
            </template>
            </draggable>
          </el-tab-pane>
          <el-tab-pane label="结束页" :name="survey.pages.length + 1 + ''">
            <div class="edit-subtitle end-page">
              <quill-editor
                ref="myQuillEditor"
                v-model="survey.suffix"
                @blur="handleBlurQuill($event, handleSaveSurvey)"
                @focus="handleFocusQuill($event)"
                :options="config"
              ></quill-editor>
              <input
                type="file"
                ref="imgInput"
                name="file"
                @change="handleFileChange('imgInput')"
                style="display: none;"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <analysisOnline v-if="showAnalysis" :title="survey.remarkName || survey.title"></analysisOnline>
    <textEditing v-if="textEdit"></textEditing>
    <link-dialog-new
      :linkQues="linkQues"
      :survey="survey"
      :letterMap="letterMap"
      :isShow="linkDialogShow"
      :activePage="activePage"
      @linkConfirm="handleLinkConfirm"
      @close="handleCloseLinkDialog"
    ></link-dialog-new>
    <link-dialog-star
      :linkQues="linkQues"
      :survey="survey"
      :isShow="linkDialogStarShow"
      @linkConfirm="handleLinkStarConfirm"
      @close="linkDialogStarShow = false"
    ></link-dialog-star>
    <share-dialog :shareSurvey="survey" :dialogShow.sync="shareDialogShow"></share-dialog>
    <batch-update-dialog
      :dialogShow.sync="batchUpdateDialogShow"
      :batchOptionUpdate.sync="batchOptionUpdate"
      @confirm="confirmBatchUpdate"
    ></batch-update-dialog>
    <edit-dialog :dialogShow.sync="textEditingShow" @confirm="confirmTextEditing"></edit-dialog>
    <collect-dialog
      :dialogShow.sync="collectDialogShow"
      :collectList="collectList"
      :collectQues="collectQues"
      :showLikeHeart.sync="showLikeHeart"
      :checkCollectDir.sync="checkCollectDir"
      @updateCollectList="updateCollectList"
      @confirmDir="getCollectList"
      @confirm="getCollection"
    ></collect-dialog>
    <collect-dir-dialog
      :dialogShow.sync="collectDirDialogShow"
      :collectQues="collectQues"
      @confirm="getCollection"
    ></collect-dir-dialog>
  </div>
</template>

<script>
import http from "../utils/http";
import draggable from "vuedraggable";
import analysis from "../components/analysis.vue";
import analysisOnline from "../components/analysisOnline.vue";
import textEditing from "../components/textEditing.vue";
import linkDialogNew from "../components/linkDialog-new.vue";
import linkDialogStar from "../components/linkDialogStar.vue";
import likeAnimate from "../components/likeAnimate";
import { quillEditor } from "vue-quill-editor";
import { DOMAIN } from "../utils/api";
import { uploadImgType } from "../utils/constant";
import shareDialog from "../components/shareDialog.vue";
import editDialog from "../components/editDialog.vue";
import collectDirDialog from "../components/collectDirDialog.vue";
import collectDialog from "../components/collectDialog.vue";
import batchUpdateDialog from "../components/batchUpdateDialog";
import {
  radio,
  checkbox,
  radioNew,
  checkboxNew,
  textArea,
  star,
  matrixRadio,
  matrixCheckbox,
  matrixStar,
  wqselect,
  sort,
  description,
  upload,
  chainedSelects,
  textMultiple,
  date,
  region,
  wjSwitch,
  wjPageEditor
} from "../components/ques-widget.js";
import "../assets/quill-core.css";
import "../assets/quill-snow.css";
import { deepClone, uuid, MSG } from "../utils/utils";
import { questionDataSetsMixin } from "../utils/mixins.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import uploadFile from "../utils/uploadFile";
import { questionsTypeOption, quesTypeMap, letterMap } from "../utils/constant";
import Template from './template.vue';
let set_lock = false;
let tempTitle = "";

let batchChangeType = "";
let tempOptions = null;
let focusHeight = 0;

export default {
  name: "TemplateEdit",
  mixins: [questionDataSetsMixin],
  data() {
    return {
      interface: {
        getSurvey: `/template/get`,
        saveSurvey: `/template/save`,
        createSurvey: `/template/create`,
        startRecycle: `/survey/startRecycle`,
        pauseRecycle: `/survey/suspendRecycle`,
        qrcode: `${DOMAIN}/survey/qrcode`,
        collect: `/survey/collect`,
        delCollect: `/survey/delQuestion`,
        collectionList: `/survey/collectionList`,
        addDir: `/questionDir/addDir`,
        renameDir: `/questionDir/rename`,
        deleteDir: `/questionDir/deleteDir`,
        listDir: `/questionDir/listDir`,
        quesBankList: `/survey/commonList`
      },
      survey: {
        pages: [],
        settings: {
          titleIndex: false,
          ipLimit: false
        }
      },
      userList: [],
      loading: false,
      activePage: "1",
      focusQues: null,
      letterMap: letterMap,
      tempQuesData: {},
      isNew: false,
      isEditTitle: false,
      showAnalysis: false,
      activeTab: 0,
      linkDialogShow: false,
      linkDialogStarShow: false,
      linkQues: {},
      linkQuesId: null,
      settingDialogShow: false,
      textEditingShow: false,
      collectDialogShow: false,
      collectDirDialogShow: false,
      isShowAddDirBtn: true,
      tempDirId: 0,
      collectList: [],
      tempCollectList: [],
      checkCollectDir: [],
      newDirName: "",
      collectQues: null,
      recyleStatus: 0,
      textEdit: false,
      textEditButton: "文本编辑",
      editRule: {
        title: [
          {
            required: true,
            message: "请输入题干",
            trigger: "blur"
          }
        ]
      },
      optRule: {
        text: [
          {
            required: true,
            message: "请输入该选项",
            trigger: "blur"
          }
        ]
      },
      shareDialogShow: false,
      batchUpdateDialogShow: false,
      batchOptionUpdate: "",
      content: "123",
      activeBank: "0",
      sidebarActive: "0",
      showLikeHeart: false,
      bankArr: [],
      commonQuesArr: [],
      tempQuill: "",
      config: {
        theme: "snow", // 主题
        placeholder: "",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline"],
              [{ color: [] }, { background: [] }],
              ["link", "image"]
            ]
          }
        }
      },
      baseConfig: {
        theme: "snow", // 主题
        placeholder: "",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline"],
              [{ color: [] }, { background: [] }],
              ["link"]
            ]
          }
        }
      },
      quesTypeMap: quesTypeMap,
      questionsTypeOption: questionsTypeOption,
      collectPage: 1,
      collectTotal: 15,
      recycleCount: 0,
      isSave: true,
      currentEditor: null,
      isNewSurvey: false,
      canEdit: true
    };
  },
  created() {
    if (this.SURVEY_ID) {
      this.getSurvey();
    } else {
      this.createSurvey();
      this.isNewSurvey = true;
    }
    this.getCollection();
    this.getCommonQuesList();
    this.getCollectList();
  },
  mounted() {
    this.$refs.myQuillEditor.quill
      .getModule("toolbar")
      .addHandler("image", this.imgHandler);
    this.showAnalysis = this.$route.query.tab === "analysis";
    this.textEdit = this.$route.query.tab === "textedit";
    this.activeTab = Number(this.$route.query.tab === "analysis");
    this.textEditButton =
      this.$route.query.tab === "textedit" ? "高级编辑" : "文本编辑";
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (set_lock) {
      this.handleSaveSurvey();
    }
    if (this.focusQues) {
      this.$confirm("离开页面后将丢失未保存的内容", "确定离开?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  watch: {
    "$route.query.id": function(val) {
      this.$router.push({
        path: "/home/templateEdit",
        query: {
          id: this.survey.id,
          tab: this.$route.query.tab
        }
      });
    },
    "$route.query.tab": function() {
      this.showAnalysis = this.$route.query.tab === "analysis";
      this.activeTab = this.$route.query.tab === "analysis" ? 1 : 0;
      this.textEdit = this.$route.query.tab === "textedit";
      this.textEditButton =
        this.$route.query.tab === "textedit" ? "高级编辑" : "文本编辑";
    }
  },
  computed: {
    SURVEY_ID() {
      return this.$route.query.id;
    },
    cannotDrag() {
      return !!this.focusQues;
    },
    surveyIsEvaluate() {
      return this.statFlags.length > 0 || this.evaluateFlags.length > 0;
    }
  },
  components: {
    draggable,
    analysis,
    textEditing,
    radio,
    wqselect,
    sort,
    description,
    upload,
    checkbox,
    textArea,
    star,
    matrixRadio,
    matrixCheckbox,
    matrixStar,
    chainedSelects,
    textMultiple,
    date,
    region,
    likeAnimate,
    analysisOnline,
    radioNew,
    checkboxNew,
    linkDialogNew,
    linkDialogStar,
    wjSwitch,
    quillEditor,
    shareDialog,
    editDialog,
    collectDirDialog,
    collectDialog,
    batchUpdateDialog,
    Template
  },
  methods: {
    // 点击图片ICON触发事件
    imgHandler(state) {
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        let fileInput = this.$refs["imgInput"];
        fileInput.click(); // 加一个触发事件
      }
    },
    handleFileChange(id) {
      let files = this.$refs.imgInput.files;
      uploadFile(files, uploadImgType, 2).then(url => {
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, "image", url);
        quill.setSelection(length + 1);
        this.handleSaveSurvey();
      });
      this.$refs.imgInput.value = "";
    },
    createSurvey() {
      http.get(this.interface.createSurvey).then(response => {
        const { code, data, message } = response;
        if (code === 1) {
          this.isSave = false;
          this.$router.push({
            path: "/home/templateEdit",
            query: {
              id: data.id
            }
          });
          this.survey = {
            id: data.id,
            title: "问卷标题",
            prefix:
              "尊贵的用户您好，感谢您能抽出几分钟时间来参加本次答题，我们会根据您的建议，为您提供更好的服务~",
            remarkName: "",
            pages: [
              {
                id: uuid(),
                questions: [],
                index: 0
              }
            ],
            settings: {
              titleIndex: true,
              ipLimit: false
            },
            suffix:
                '<p><img style="width: 250px" src="https://wos.58cdn.com.cn/aBYxWvUtaDg/wenjuanupload/happy_2020722204917911.png" alt=""></p><p>问卷已提交成功，感谢参与！</p>',
            startTime: null,
            endTime: null,
            status: 2,
            evaluateFlag: false,
            showStatFlag: false,
            hash: data.hash,
            createTime: `${new Date().getTime()}`,
            updateTime: null,
            url: `https://wenjuan.58.com/s/?id=${data.id}&hash=${data.hash}`,
            pageCount: 1,
            topicCount: 0,
            ipLimited: false,
            source: "pc",
            version: 1,
            surveyVersion: 0
          };
          localStorage.setItem("survey_id", data.id);
          window.sessionStorage.setItem("surveyVersion", 0);
        } else {
          MSG.error(message);
        }
      });
    },
    getSurvey(cb) {
      http
        .get(this.interface.getSurvey, {
          templateId: this.SURVEY_ID
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.survey = data;
            tempTitle = this.survey.title;
            window.sessionStorage.setItem(
              "surveyVersion",
              this.survey.surveyVersion
            );
            this.resetOrder();
            this.$nextTick(() => {
              cb && cb();
            });
          } else {
            MSG.error(message);
          }
        });
    },
    getCollection(page, dirId) {
      http
        .get(this.interface.collectionList, {
          page: page || this.collectPage,
          pageSize: 15,
          dirId: dirId
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            if (data && data.questions) {
              this.bankArr = data.questions;
              this.collectTotal = data.totalCount;
            }
          } else {
            MSG.error(message);
          }
        });
    },
    getCommonQuesList() {
      http.get(this.interface.quesBankList).then(response => {
        const { code, data, message } = response;
        if (code === 1) {
          if (data && data.questions) {
            this.commonQuesArr = data.questions;
          }
        } else {
          MSG.error(message);
        }
      });
    },
    handleQuestionType(value) {
      tempOptions = this.tempQuesData.options || tempOptions;
      const ques = {
        select: this.questionDataSets.selectNewQues,
        sort: this.questionDataSets.sortNewQues,
        upload: this.questionDataSets.uploadNewQues,
        radio: this.questionDataSets.radioNewQues,
        checkbox: this.questionDataSets.checkboxNewQues,
        star: this.questionDataSets.starNewQues,
        textarea: this.questionDataSets.textareaNewQues,
        matrixRadio: this.questionDataSets.matrixRadionNewQues,
        matrixCheckbox: this.questionDataSets.matrixCheckboxNewQues,
        matrixStar: this.questionDataSets.matrixStarNewQues,
        textMultiple: this.questionDataSets.textMultipleNewQues,
        chainedSelects: this.questionDataSets.chainedSelectsNewQues,
        date: this.questionDataSets.dateNewQues,
        region: this.questionDataSets.regionNewQues
      }[value];
      this.handleChangeTypeData(ques);
    },
    handleChangeTypeData(tempQues) {
      let tempNewQues = deepClone(tempQues, {});
      let {
        title,
        description,
        index,
        realIndex,
        id,
        goto: gotoTemp,
        options = [],
        subTitles = []
      } = this.tempQuesData;
      this.tempQuesData = {
        ...tempNewQues,
        goto: gotoTemp,
        title,
        description,
        index,
        realIndex,
        id
      };
      if (tempNewQues.hasOwnProperty("options") && tempOptions) {
        tempOptions.forEach(val => {
          val.goto = "";
          if (tempNewQues.type === "radio" || tempNewQues.type === "checkbox") {
            val.visible = [];
            val.mulKey = "";
            val.mulToQues = [];
            val.mulToQuesId = [];
          }
        });
        this.tempQuesData = { ...this.tempQuesData, options: tempOptions };
      }
      if (tempNewQues.hasOwnProperty("subTitles")) {
        subTitles.forEach(val => {
          if (tempNewQues.type === "matrix-radio") {
            val.checked = "";
          } else if (tempNewQues.type === "matrix-checkbox") {
            val.checked = [];
          } else {
            val.checkedStar = -1;
          }
        });
        this.tempQuesData = { ...this.tempQuesData, subTitles };
      }
    },
    handleSelectPage(item) {
      item.toQues = this.linkQues.index + 1;
    },
    handleTabsEdit(targetName, action) {
      if (action === "add") {
        this.survey.pages.push({
          id: uuid(),
          questions: [],
          index: this.survey.pages.length
        });
        this.activePage = this.survey.pages.length;
        this.resetOrder();
        this.handleSaveSurvey();
      }
      if (action === "remove") {
        this.$confirm("删除该页, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const tabs = deepClone(this.survey.pages, []);
          let activeName = this.activePage;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (index + 1 === +targetName) {
                const nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = `${index + 1}`;
                }
              }
            });
          }
          this.activePage = activeName;
          this.survey.pages = tabs.filter(
            (tab, idx) => idx + 1 !== +targetName
          );
          this.resetOrder();
          this.handleSaveSurvey();
        });
      }
    },
    shake() {
      MSG.error("当前编辑未完成");
    },
    handleFocus(e, ques) {
      if (this.focusQues) {
        this.shake();
        return;
      }
      this.tempQuesData = deepClone(ques, {});
      this.focusQues = ques.id;
      focusHeight = e.currentTarget.clientHeight;
    },
    handleCancel(e) {
      let eleHeight =
        e.target.parentElement.parentElement.parentElement.clientHeight;
      tempOptions = null;
      if (this.isNew) {
        this.survey.pages[+this.activePage - 1].questions.pop();
        this.resetOrder();
      }
      this.isNew = false;
      this.tempQuesData = null;
      this.focusQues = null;
      this.$nextTick(() => {
        const _el = document.getElementsByClassName("edit-part")[0];
        _el.scrollTop = _el.scrollTop - eleHeight + focusHeight;
      });
    },
    handleConfirm(e, ques) {
      tempOptions = null;
      let eleHeight =
        e.target.parentElement.parentElement.parentElement.clientHeight;
      let isBlank =
        !this.tempQuesData.title ||
        (this.tempQuesData.options &&
          this.tempQuesData.options.length === 0 &&
          !this.tempQuesData.referFlag) ||
        (this.tempQuesData.referFlag && this.tempQuesData.refer.trim() === "");
      this.tempQuesData.options &&
        this.tempQuesData.options.forEach(val => {
          if (val.text.trim() === "") {
            isBlank = true;
          }
        });
      if (
        this.tempQuesData.evaluateFlag &&
        this.tempQuesData.assess.options.length === 0
      ) {
        MSG.error("请输入评测题正确答案");
        return;
      } else if (
        this.tempQuesData.hasOwnProperty("subTitles") &&
        this.tempQuesData.subTitles.length === 0
      ) {
        MSG.error("请对问题进行设置");
        return;
      } else if (isBlank) {
        this.shake();
        return;
      }
      for (let key in ques) {
        if (!this.tempQuesData.hasOwnProperty(key)) {
          delete ques[key];
        }
      }
      Object.assign(ques, deepClone(this.tempQuesData, {}));
      this.isNew = false;
      this.handleSaveSurvey();
      this.$nextTick(() => {
        const _el = document.getElementsByClassName("edit-part")[0];
        _el.scrollTop = _el.scrollTop - eleHeight + focusHeight;
      });
    },
    addCheckboxOpt(opt) {
      let obj = {
        id: uuid(),
        goto: "",
        noRandom: false,
        text: "",
        exclusive: false,
        mulKey: "",
        mulToQues: [],
        mulToQuesId: [],
        visible: []
      };
      if (opt.length > 0 && opt[opt.length - 1].id === "98") {
        opt.splice(opt.length - 1, 0, obj);
        this._focusOption(opt, 2);
      } else {
        opt.push(obj);
        this._focusOption(opt, 1);
      }
    },
    addRadioOpt(opt) {
      let obj = {
        id: uuid(),
        goto: "",
        noRandom: false,
        text: "",
        mulKey: "",
        mulToQues: [],
        mulToQuesId: [],
        visible: []
      };
      if (opt.length > 0 && opt[opt.length - 1].id === "98") {
        opt.splice(opt.length - 1, 0, obj);
        this._focusOption(opt, 2);
      } else {
        opt.push(obj);
        this.$nextTick(() => {
          this._focusOption(opt, 1);
          window.localStorage.setItem("new_option_id", opt[opt.length - 1].id);
        });
      }
    },

    resetOrder() {
      let tempSum = 0;
      let count = 0,
        _optArr = [],
        _optGotoArr = new Set(),
        _visibleArr = [];
      this.survey.pages.forEach(page => {
        count += page.questions.length;
      });
      this.survey.pages.forEach(page => {
        page.questions.forEach(ques => {
          if (+ques.goto > count - 1) {
            ques.goto = "-1";
          }
          if (ques.type === "radio" || ques.type === "checkbox") {
            ques.options.forEach(opt => {
              if (+opt.goto > 0) {
                if (+opt.goto > count - 1) {
                  opt.goto = "";
                } else {
                  if (_optArr[+opt.goto]) {
                    _optArr[+opt.goto].push({
                      opt: opt
                    });
                  } else {
                    _optArr[+opt.goto] = [
                      {
                        opt: opt
                      }
                    ];
                  }
                  _optGotoArr.add(+opt.goto);
                }
              }
              if (opt.visible.length > 0) {
                opt.visible.forEach(val => {
                  if (_visibleArr.indexOf(val) === -1) _visibleArr.push(val);
                });
              }
            });
          }
        });
      });
      let descCount = 0;
      this.survey.pages.forEach((val, idx) => {
        val.index = idx;
        val.questions.forEach((ques, i) => {
          if (ques.type === "description") {
            descCount++;
            return;
          }
          ques.index = i + tempSum - descCount;
          ques.realIndex = i + tempSum - descCount;
        });
        tempSum += val.questions.length;
      });
    },
    handleDragEnd() {
      this.resetOrder();
      this.handleSaveSurvey();
    },
    handleAddRadio() {
      this.handleAddQuestion(this.questionDataSets.radioNewQues);
    },
    handleAddQuestion(quesInit) {
      if (this.focusQues) {
        this.shake();
        return;
      }
      let timer = setInterval(() => {
        if (!this.isEditTitle) {
          clearInterval(timer);
          const id = uuid();
          const newQues = { ...quesInit, id };
          this.isNew = true;
          this.survey.pages[+this.activePage - 1].questions.push(newQues);
          this.resetOrder();
          this.tempQuesData = deepClone(newQues, {});
          this.focusQues = id;
          this.scrollBottom();
        }
      }, 10);
    },
    handleAddSelect() {
      this.handleAddQuestion(this.questionDataSets.selectNewQues);
    },
    handleAddSort() {
      this.handleAddQuestion(this.questionDataSets.sortNewQues);
    },
    handleAddDiscription() {
      this.handleAddQuestion(this.questionDataSets.descriptionNewQues);
    },
    handleAddUpload() {
      this.handleAddQuestion(this.questionDataSets.uploadNewQues);
    },
    handleAddCheckbox() {
      this.handleAddQuestion(this.questionDataSets.checkboxNewQues);
    },
    handleAddTextarea() {
      this.handleAddQuestion(this.questionDataSets.textareaNewQues);
    },
    handleAddStar() {
      this.handleAddQuestion(this.questionDataSets.starNewQues);
    },
    handleAddChainedSelects() {
      this.handleAddQuestion(this.questionDataSets.chainedSelectsNewQues);
    },
    _focusOption(opt, index) {
      this.$nextTick(() => {
        let _opt = document.getElementById("opt_" + opt[opt.length - index].id);
        _opt && _opt.focus();
        _opt = null;
      });
    },
    handleAddSelectOpt(opt) {
      if (opt.length > 0 && opt[opt.length - 1].id === "98") {
        opt.splice(opt.length - 1, 0, {
          id: uuid(),
          goto: "",
          noRandom: false,
          toPage: -1,
          toQues: 0,
          display: {},
          exclusive: false,
          text: ""
        });
        this._focusOption(opt, 2);
      } else {
        opt.push({
          id: uuid(),
          goto: "",
          noRandom: false,
          display: {},
          exclusive: false,
          text: ""
        });
        this._focusOption(opt, 1);
      }
    },
    handleAddSortOpt(opt) {
      let obj = {
        id: uuid(),
        goto: "",
        noRandom: false,
        display: {},
        exclusive: false,
        text: ""
      };
      if (opt.length > 0 && opt[opt.length - 1].id === "98") {
        opt.splice(opt.length - 1, 0, obj);
        this._focusOption(opt, 2);
      } else {
        opt.push(obj);
        this._focusOption(opt, 1);
      }
    },
    addMatrixOpt(opt) {
      opt.push({
        id: uuid(),
        text: ""
      });
      this._focusOption(opt, 1);
    },
    addRadioSubTitles(title) {
      title.push({
        id: uuid(),
        text: "",
        checked: ""
      });
      this._focusOption(title, 1);
    },
    addCheckboxSubTitles(title) {
      title.push({
        id: uuid(),
        text: "",
        checked: []
      });
      this._focusOption(title, 1);
    },
    addStarSubTitles(title) {
      title.push({
        id: uuid(),
        text: "",
        checkedStar: -1
      });
      this._focusOption(title, 1);
    },
    handleAddMatrixRadio() {
      this.handleAddQuestion(this.questionDataSets.matrixRadionNewQues);
    },
    handleAddMatrixCheckbox() {
      this.handleAddQuestion(this.questionDataSets.matrixCheckboxNewQues);
    },
    handleAddMatrixStar() {
      this.handleAddQuestion(this.questionDataSets.matrixStarNewQues);
    },
    handleAddTextMultiple() {
      this.handleAddQuestion(this.questionDataSets.textMultipleNewQues);
    },
    handleAddDate() {
      this.handleAddQuestion(this.questionDataSets.dateNewQues);
    },
    handleAddRegion() {
      this.handleAddQuestion(this.questionDataSets.regionNewQues);
    },
    openPreview() {
      window.sessionStorage.setItem(
        "previewUrl",
        `${this.survey.url}&type=template`
      );
      this.handleSaveSurvey(() => {
        this.$router.push({
          path: "/preview"
        });
      });
    },
    handleTextEditing() {
      if (this.textEdit) {
        this.$router.push({
          path: "/home/templateEdit",
          query: {
            id: this.SURVEY_ID
          }
        });
        this.textEditButton = "文本编辑";
        this.handleSaveSurvey();
      } else {
        this.textEditingShow = true;
      }
    },
    handleCopy(e, ques, idx) {
      let added = deepClone(ques, {});
      if (ques.type === "radio" || ques.type === "checkbox") {
        added = Object.assign(added, {
          id: uuid(),
          goto: "-1"
        });
      } else {
        Object.assign(added, {
          id: uuid(),
          goto: "-1"
        });
      }
      added.options &&
        added.options.forEach(val => {
          if (val.id !== "98") {
            val.id = uuid();
          }
          if (val.goto) {
            val.goto = "";
            if (val.visible) val.visible = [];
            if (val.mulKey) val.mulKey = "";
            if (val.mulToQues) val.mulToQues = [];
            if (val.mulToQuesId) val.mulToQuesId = [];
          }
        });
      added.subTitles &&
        added.subTitles.forEach(val => {
          val.id = uuid();
        });
      this.survey.pages[this.activePage - 1].questions.splice(
        idx + 1,
        0,
        added
      );
      this.resetOrder();
      this.handleSaveSurvey();
      this.$nextTick(() => {
        let ele = e.target.parentElement.parentElement.parentElement;
        const _el = document.getElementsByClassName("edit-part")[0];
        _el.scrollTop = _el.scrollTop + ele.clientHeight;
      });
    },
    handleDelete(ques, idx) {
      if (this.recycleCount > 0) {
        this.$confirm(
          "该问卷已有" + this.recycleCount + "次发放, 是否删除该题?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.survey.pages[this.activePage - 1].questions.splice(idx, 1);
            this.resetOrder();
            this.handleSaveSurvey();
          })
          .catch(() => {});
      } else {
        this.survey.pages[this.activePage - 1].questions.splice(idx, 1);
        this.resetOrder();
        this.handleSaveSurvey();
      }
    },
    handleLink(ques) {
      if (ques.type == "radio" || ques.type == "checkbox") {
        this.linkQues = deepClone(ques, {});
        this.linkQuesId = ques.id;
        this.linkDialogShow = true;
      } else if (ques.type == "star") {
        this.linkQues = deepClone(ques, {});
        this.linkQuesId = ques.id;
        this.linkDialogStarShow = true;
      } else {
        MSG.warning("仅单选题、多选题和打分题可设置跳转逻辑!");
      }
    },
    handleRenameDir(item) {
      this.$set(item, "isRenameDir", true);
      this.$set(item, "newDirName", item.dirName);
      this.$nextTick(() => {
        document
          .querySelector(".newDirNameInput-" + item.dirId)
          .children[0].focus();
      });
    },
    handleBlurRenameDir(item) {
      item.isRenameDir = false;
      http
        .get(this.interface.renameDir, {
          dirId: item.dirId,
          dirName: item.newDirName
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getCollectList();
          } else {
            MSG.error(message);
          }
        });
    },
    handleDeleteDir(item) {
      this.$confirm("删除文件夹，文件夹中的内容也会删除，是否确认？", {
        confirmButtonText: "确认删除",
        cancelButtonText: "取消删除",
        type: "warning"
      })
        .then(() => {
          this._deleteDir(item);
        })
        .catch(() => {});
    },
    _deleteDir(item) {
      http
        .get(this.interface.deleteDir, {
          dirId: item.dirId
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getCollectList();
          } else {
            MSG.error(message);
          }
        });
    },
    updateCollectList(val) {
      if (val === "push") {
        this.collectList.push({ dirId: -1 });
      } else {
        this.collectList.pop();
      }
    },
    getCollectList() {
      http
        .get(this.interface.listDir, {
          page: this.currentPage,
          pageSize: this.pageSize
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.collectList = data.recordList || [];
            this.collectList.unshift({ dirId: 0, dirName: "默认收藏夹" });
            if (
              this.tempCollectList.length &&
              this.tempCollectList.length < this.collectList.length
            ) {
              let dirIdList = this.tempCollectList.map(item => {
                return item.dirId;
              });
              this.collectList.forEach(item => {
                if (dirIdList.indexOf(item.dirId) == -1) {
                  this.checkCollectDir = item.dirId;
                }
              });
            } else {
              this.checkCollectDir = 0;
            }
            this.tempCollectList = deepClone(this.collectList);
          } else {
            MSG.error(message);
          }
        });
    },
    handleCollect(ques) {
      this.getCollectList();
      this.collectDialogShow = true;
      this.isShowAddDirBtn = true;
      this.collectQues = ques;
    },
    handleCollapse(dirId) {
      this.getCollection(1, dirId);
    },
    handleAddOtherRadio(data) {
      data.blankSetting.push({
        attachId: "98"
      });
      data.options.push({
        id: "98",
        noRandom: true,
        text: "其他___________",
        goto: "",
        mulKey: "",
        mulToQues: [],
        visible: []
      });
    },
    handleAddOtherCheckbox(data) {
      data.blankSetting.push({
        attachId: "98"
      });
      data.options.push({
        id: "98",
        noRandom: true,
        text: "其他___________",
        exclusive: false,
        goto: "",
        mulKey: "",
        mulToQues: [],
        mulToQuesId: [],
        visible: []
      });
    },
    handleAddOtherselect(data) {
      data.blankSetting.push({
        attachId: "98"
      });
      data.options.push({
        id: "98",
        noRandom: true,
        text: "其他___________",
        exclusive: false,
        display: {}
      });
    },
    handleConfirmLink() {
      const _pagelink = this.linkQues.toPage;
      const _queslink = this.linkQues.toQues;
      if (_pagelink >= 0 && _queslink >= 0) {
        this.linkQues.goto = `${_pagelink}-${_queslink}`;
      } else {
        this.linkQues.goto = "";
      }
      this.linkQues.options.forEach(val => {
        if (val.toPage >= 0 && val.toQues >= 0) {
          val.goto = `${val.toPage}-${val.toQues}`;
        } else {
          val.goto = "";
          val.toPage = -1;
          val.toQues = 0;
        }
      });
      for (let i = 0; i < this.survey.pages.length; i++) {
        for (let j = 0; j < this.survey.pages[i].questions.length; j++) {
          if (this.survey.pages[i].questions[j].id === this.linkQuesId) {
            Object.assign(this.survey.pages[i].questions[j], this.linkQues);
            this.linkDialogShow = false;
            this.handleSaveSurvey();
            return;
          }
        }
      }
    },
    //新版逻辑跳转确认
    handleLinkConfirm(opt) {
      if (opt.mulKey !== "") {
        this.linkQues.options[opt.optIdx].mulKey = opt.mulKey;
        this.linkQues.options[opt.optIdx].mulToQues = opt.mulToQues;
        this.linkQues.options[opt.optIdx].mulToQuesId = opt.mulToQuesId;
      } else {
        this.linkQues.options.forEach(val => {
          val.mulKey = "";
          val.mulToQues = [];
          val.mulToQuesId = [];
        });
      }
      if (opt.mulKeyId) {
        this.linkQues.options[opt.optIdx].mulKeyId = opt.mulKeyId;
        this.linkQues.options[opt.optIdx].mulToQues = opt.mulToQues;
        this.linkQues.options[opt.optIdx].mulToQuesId = opt.mulToQuesId;
      } else {
        this.linkQues.options.forEach(val => {
          val.mulKeyId = "";
          val.mulToQues = [];
          val.mulToQuesId = [];
        });
      }
      if (this.linkQues.type === "radio" || this.linkQues.type === "checkbox") {
        this.linkQues.options.forEach((val, i) => {
          val.goto = opt.optLink[i];
        });
        if (this.survey.version == 1) {
          this.linkQues.options.forEach((val, i) => {
            val.gotoId = opt.optLink[i];
            val.goto = this.calcIndexById(val.gotoId);
          });
        }
      }
      if (opt.visible.length > 0) {
        this.linkQues.options[opt.optIdx].visible = opt.visible;
      } else {
        this.linkQues.options.forEach(val => {
          val.visible = [];
        });
      }
      this.linkQues.goto = opt.noReasonLink;
      if (this.survey.version == 1) {
        if (opt.visibleId && opt.visibleId.length > 0) {
          this.linkQues.options[opt.optIdx].visibleId = opt.visibleId;
        } else {
          this.linkQues.options.forEach(val => {
            val.visibleId = [];
          });
        }
        if (opt.gotoQId) {
          this.linkQues.gotoQId = opt.gotoQId;
        }
      }
      for (let i = 0; i < this.survey.pages.length; i++) {
        for (let j = 0; j < this.survey.pages[i].questions.length; j++) {
          if (this.survey.pages[i].questions[j].id === this.linkQuesId) {
            Object.assign(this.survey.pages[i].questions[j], this.linkQues);
            this.handleSaveSurvey();
            return;
          }
        }
      }
    },
    //打分题跳转逻辑
    handleLinkStarConfirm(list) {
      this.linkQues.starEntityList = list;
      for (let i = 0; i < this.survey.pages.length; i++) {
        for (let j = 0; j < this.survey.pages[i].questions.length; j++) {
          if (this.survey.pages[i].questions[j].id === this.linkQuesId) {
            Object.assign(this.survey.pages[i].questions[j], this.linkQues);
            this.handleSaveSurvey();
            return;
          }
        }
      }
    },
    handleEditTab() {
      if (this.survey.status == 1) {
        this.$confirm("该问卷正在发放，请暂停发放后再编辑?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.handlePauseRecycle(() => {
            this.$router.push({
              path: "/home/templateEdit",
              query: {
                id: this.$route.query.id
              }
            });
          });
        });
      } else {
        this.$router.push({
          path: "/home/templateEdit",
          query: {
            id: this.$route.query.id
          }
        });
      }
    },
    calcIndexById(id) {
      let count = 0;
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          if (id == _page.questions[j].id) {
            return count;
          }
          if (_page.questions[j].type !== "description") {
            count++;
          }
        }
      }
    },
    calcIndexByPageId(id) {
      let count = 0;
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          if (_page.id == id) {
            return count;
          }
          count++;
        }
      }
      return -1;
    },
    calcVisibleQues(toQues) {
      let count = 0;
      let list = [];
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          let id = _page.questions[j].id;
          if (toQues.indexOf(id) > -1) {
            list.push(count);
          }
          if (_page.questions[j].type != "description") {
            count++;
          }
        }
      }
      return list;
    },
    handleUpdateLogic() {
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          let ques = _page.questions[j];
          if (ques.type == "radio" || ques.type == "checkbox") {
            ques.options.forEach((val, i) => {
              if (val.mulKeyId) {
                val.mulKey =
                  this.calcIndexById(val.mulKeyId.split("_")[0]) +
                  "-" +
                  val.mulKeyId.split("_")[1];
                val.mulToQues = this.calcVisibleQues(val.mulToQuesId);
              }
              if (val.visibleId && val.visibleId.length > 0) {
                val.visible = this.calcVisibleQues(val.visibleId);
              }
              if (val.gotoId && val.gotoId.length > 0) {
                val.goto = this.calcIndexById(val.gotoId);
                if (val.gotoId == "-2") {
                  val.goto = "-2";
                }
              }
            });
            if (ques.gotoQId && ques.gotoQId.length > 0) {
              if (ques.goto != "-2") {
                ques.goto = this.calcIndexByPageId(ques.gotoQId);
              }
            }
          }
          if (ques.type == "star") {
            if (ques.starEntityList && ques.starEntityList.length > 0) {
              ques.starEntityList.forEach(item => {
                item.goto = this.calcIndexById(item.quetionId);
              });
            }
          }
        }
      }
    },
    handleSaveSurvey(cb) {
      if (
        !this.survey.pages ||
        (this.survey.pages && this.survey.pages.length == 0)
      ) {
        return;
      }
      this.initLoopFlag();
      this.handleUpdateLogic();
      this.survey.surveyVersion = window.sessionStorage.getItem(
        "surveyVersion"
      );
      this.survey.source = this.survey.source || "pc";
      if (tempTitle == this.survey.remarkName) {
        this.survey.remarkName = this.survey.title;
      }
      http
        .post(this.interface.saveSurvey, {
          templateId: this.SURVEY_ID,
          templateJson: JSON.stringify(this.survey)
        })
        .then(response => {
          const { code, data, message = '保存成功'  } = response;
          if (code != 98) {
            this.focusQues = null;
            this.tempQuesData = null;
          }
          if (code === 1) {
            window.sessionStorage.setItem("surveyVersion", data);
            this.survey.surveyVersion = data;
            tempTitle = this.survey.title;
          }
          if (typeof cb === "function") {
            cb();
            return;
          }
          if (code === 1) {
            this.isSave = true;
            MSG.success(message);
          } else if (code === 98) {
            let message = JSON.parse(message);
            let msg = message.msg;
            let word = message.array[0].word;
            MSG.error(msg + '"' + word + '"');
          } else {
            MSG.error(message);
          }
          this.isEditTitle = false;
        });
    },
    handleSaveTitle(editor) {
      this.handleSaveSurvey();
    },
    scrollBottom() {
      this.$nextTick(() => {
        const _el = document.getElementsByClassName("edit-part")[0];
        _el.scrollTop = _el.scrollHeight - _el.clientHeight;
      });
    },
    handleBatchChange(opts, type) {
      let optionLines = "";
      opts.forEach(val => {
        if (val.id === "98") return;
        optionLines += val.text + "\n";
      });
      batchChangeType = type;
      this.batchOptionUpdate = optionLines;
      this.batchUpdateDialogShow = true;
    },
    confirmBatchUpdate() {
      const optsText = this.batchOptionUpdate.trim().split("\n");
      if (this.tempQuesData.type.indexOf("matrix") > -1) {
        if (batchChangeType === "subTitles") {
          this.tempQuesData.subTitles = this.handleUpdate(
            this.tempQuesData.subTitles,
            optsText,
            batchChangeType
          );
        } else {
          this.tempQuesData.options = this.handleUpdate(
            this.tempQuesData.options,
            optsText,
            batchChangeType
          );
        }
      } else {
        let lgt = this.tempQuesData.options.length;
        if (lgt > 0 && this.tempQuesData.options[lgt - 1].id === "98") {
          let noOther = this.tempQuesData.options.slice(0, lgt - 1);
          this.tempQuesData.options.splice(
            0,
            lgt - 1,
            ...this.handleUpdate(noOther, optsText)
          );
        } else {
          this.tempQuesData.options = this.handleUpdate(
            this.tempQuesData.options,
            optsText
          );
        }
      }
      this.batchUpdateDialogShow = false;
    },
    handleUpdate(arr, optsText, type) {
      for (let i = 0; i < optsText.length; i++) {
        arr = arr.slice(0, optsText.length);
        if (!arr[i]) {
          switch (this.tempQuesData.type) {
            case "radio":
              this.addRadioOpt(arr);
              break;
            case "checkbox":
              this.addCheckboxOpt(arr);
              break;
            case "select":
              this.handleAddSelectOpt(arr);
              break;
            case "sort":
              this.handleAddSortOpt(arr);
              break;
            case "matrixRadio":
              if (type === "subTitles") {
                this.addRadioSubTitles(arr);
              } else {
                this.addMatrixOpt(arr);
              }
              break;
            case "matrixCheckbox":
              if (type === "subTitles") {
                this.addCheckboxSubTitles(arr);
              } else {
                this.addMatrixOpt(arr);
              }
              break;
            case "matrixStar":
              if (type === "subTitles") {
                this.addStarSubTitles(arr);
              }
              break;
          }
          arr[i].text = optsText[i];
        } else {
          arr[i].text = optsText[i];
        }
      }
      return arr;
    },
    confirmTextEditing() {
      this.textEditButton = "高级编辑";
      this.$router.push({
        path: "/home/templateEdit",
        query: {
          tab: "textedit"
        }
      });
    },
    handleFocusQuill(e) {
      setTimeout(() => {
        this.tempQuill = e.root.innerHTML;
        set_lock = true;
      }, 20);
      e.root.parentElement.previousElementSibling.style.display = "block";
    },
    handleBlurQuill(e, callback) {
      setTimeout(() => {
        set_lock = false;
      }, 10);
      if (this.tempQuill && e.root.innerHTML !== this.tempQuill) {
        this.isEditTitle = true;
        callback && callback(e);
      }
      let children =
        e.root.parentElement.previousElementSibling.children[1]
          .firstElementChild;
      let isColorHidden = children.lastElementChild.getAttribute("aria-hidden");
      let isBgHidden = children.nextElementSibling.nextElementSibling.lastElementChild.getAttribute(
        "aria-hidden"
      );
      if (isColorHidden == "true" && isBgHidden == "true") {
        e.root.parentElement.previousElementSibling.style.display = "none";
      }
    },
    handleClickQuill(e) {},
    getCheckboxs(idx) {
      let checkboxs = [];
      for (let i = 0; i < this.survey.pages.length; i++) {
        for (let j = 0; j < this.survey.pages[i].questions.length; j++) {
          if (idx <= this.survey.pages[i].questions[j].realIndex) {
            return checkboxs;
          }
          if (this.survey.pages[i].questions[j].type === "checkbox") {
            checkboxs.push({
              id: this.survey.pages[i].questions[j].id,
              realIndex: this.survey.pages[i].questions[j].realIndex,
              title: this.removeLables(this.survey.pages[i].questions[j].title)
            });
          }
        }
      }
      return checkboxs;
    },
    initLoopFlag() {
      let count1 = 0,
        count2 = 0;
      this.survey.evaluateFlag = false;
      this.survey.showStatFlag = false;
      for (let i = 0; i < this.survey.pages.length; i++) {
        for (let j = 0; j < this.survey.pages[i].questions.length; j++) {
          if (this.survey.pages[i].questions[j].showStat) {
            this.survey.showStatFlag = true;
            count1++;
          } else if (this.survey.pages[i].questions[j].evaluateFlag) {
            this.survey.evaluateFlag = true;
            count2++;
          }
          if (count1 > 0 && count2 > 0) return;
        }
      }
    },
    handleCloseLinkDialog() {
      this.linkDialogShow = false;
      this.linkDialogStarShow = false;
    },
    handleDelBankItem(id) {
      this.$confirm("删除该题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        http
          .get(this.interface.delCollect, {
            questionId: id
          })
          .then(response => {
            const { code, data, message } = response;
            if (code === 1) {
              MSG.success("删除成功");
              this.getCollection();
            } else {
              MSG.error(message);
            }
          })
          .catch(error => {
            MSG.error(error);
          });
      });
    },
    handleClickBankItem(ques) {
      if (this.focusQues) {
        this.shake();
        return;
      }
      const id = uuid();
      const newQues = { ...ques, id };
      if (newQues.goto) newQues.goto = "-1";
      newQues.options &&
        newQues.options.forEach(val => {
          if (val.id !== "98") {
            val.id = uuid();
          }
          val.goto = "";
          if (val.visible) val.visible = [];
          if (val.mulKey) val.mulKey = "";
          if (val.mulToQues) val.mulToQues = [];
          if (val.mulToQuesId) val.mulToQuesId = [];
        });
      newQues.subTitles &&
        newQues.subTitles.forEach(val => {
          val.id = uuid();
        });
      this.isNew = true;
      this.survey.pages[+this.activePage - 1].questions.push(newQues);
      this.resetOrder();
      this.tempQuesData = deepClone(newQues);
      this.focusQues = id;
      this.$nextTick(() => {
        const _edit = document.getElementsByClassName("question-editor")[0];
        const _el = document.getElementsByClassName("edit-part")[0];
        _el.scrollTop =
          _el.scrollHeight - parseInt(getComputedStyle(_edit).height) - 140;
      });
    },
    handleSidebarChange(tab) {
      this.sidebarActive = tab.index;
    },
    handleJumpToQue(index, ques, page) {
      this.activePage = index + 1 + "";
      var start = 0;
      if (page.questions.length) {
        start = page.questions[0].index;
      }
      this.$nextTick(() => {
        const _el = document.getElementsByClassName("edit-part")[0];
        _el.scrollTop = this.activePage == 1 ? 480 : 160;
        let eles = document.querySelectorAll(".el-tabs__content .ques-cover");
        eles.forEach((ele, i) => {
          if (i >= start && i < ques.index) {
            _el.scrollTop += ele.getBoundingClientRect().height + 20;
          }
        });
      });
    },
    handleFinishedSurvey() {
      this.$router.push({
        path: "/home/template"
      });
    },
    beforeUnload() {
      if (this.focusQues || set_lock) {
        if (set_lock) {
          this.handleSaveSurvey();
          set_lock = false;
        }
        window.event.returnValue = "当前页面中有未保存的内容, 离开页面后将丢失";
      }
    }
  }
};
</script>

<style lang="scss">
.template-edit-page {
  height: calc(100% - 61px);
  .edit-page {
    height: 60px;
    line-height: 60px;
    padding: 0 10px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    .clear-fix {
      margin-top: 18px;
      margin-right: 30px;
    }
    a {
      display: block;
      float: left;
      font-size: 16px;
      padding: 0 25px;
      line-height: 24px;
      border-left: 0;
      &.active,
      &:hover {
        color: #ff552e;
      }
    }
    a.inactive {
      display: block;
      float: left;
      font-size: 16px;
      padding: 0 25px;
      line-height: 24px;
      color: #aaa;
      border-left: 0;
      &.active,
      &:hover {
        color: #aaa;
      }
    }
    .el-icon-view {
      margin-right: 5px;
    }
    .finished-btn {
      float: left;
      font-weight: normal;
      border-radius: 2px;
      width: 100px;
      height: 36px;
      padding: 10px 20px;
      margin-top: -6px;
      color: #fff;
      background-image: linear-gradient(270deg, #ff9000 0%, #ff552e 100%);
    }
  }
  .edit-main {
    height: calc(100% - 60px);
  }
  .edit-notice {
    float: left;
    width: calc(100% - 300px);
    opacity: 0.9;
    background: #f9f9f9;
    color: #666;
    height: 50px;
    line-height: 50px;
    text-align: center;
    .edit-notice-btn {
      display: inline-block;
      border: 1px solid #ff552d;
      border-radius: 2px;
      width: 80px;
      height: 30px;
      margin-top: 10px;
      line-height: 30px;
      color: #ff552d;
      margin-left: 10px;
    }
  }
  .edit-sidebar {
    width: 300px;
    height: 100%;
    float: left;
    .pager-center {
      overflow-y: auto;
    }
    .el-tabs__nav {
      width: 100%;
      border: 1px solid #eee;
      .el-tabs__item {
        width: 33.3%;
        text-align: center;
        padding: 0;
        margin: 0;
        border: 0;
        border-right: 1px solid #eee;
        &:last-child {
          border-right: 0;
        }
        color: #3c3c3c;
        &.is-active {
          color: #ff552e;
        }
      }
    }
    .el-tabs {
      background: #f9f9f9;
      padding: 15px;
      height: 100%;
      overflow-y: auto;
    }
    .el-tabs__content {
      color: #666;
      padding: 20px 0;
    }
    .el-tab-pane {
      position: relative;
    }
    .widget-item {
      width: 100%;
      background-color: #fff;
      height: 40px;
      line-height: 40px;
      padding-left: 10px;
      margin: 0 auto 10px;
      border: 1px solid #eee;
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .widget-icon {
        margin-right: 10px;
      }
    }
    .widget-item-exam-disable {
      background-color: #ddd;
      cursor: no-drop;
    }
    .outline-item {
      margin-bottom: 15px;
    }
    .outline-title {
      line-height: 30px;
    }
    .ques-item {
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      border: 1px solid #eee;
      position: relative;
      margin-bottom: 10px;
      cursor: move;
      i {
        position: absolute;
        left: 8px;
        top: 12px;
      }
      .question-content {
        padding: 0 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .el-tabs__header {
      background-color: #fff;
      .el-tabs__item {
        color: #666;
        &.is-active {
          color: #fff;
          background-image: linear-gradient(270deg, #ff9000 0%, #ff552e 100%);
        }
      }
    }
    .el-collapse {
      padding: 5px 20px 10px;
      background-color: #fff;
      &.collect-page {
        .el-collapse-item__header {
          color: #333;
        }
        .el-collapse-item__content {
          color: #666;
        }
      }
      .el-collapse-item__header {
        height: 40px;
        line-height: 40px;
        &.is-active {
          border-bottom-color: #ebeef5;
        }
      }
      .el-collapse-item__arrow {
        line-height: 40px;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
      .el-collapse-item__wrap {
        border-bottom: 0;
      }
    }
    .bank-list {
      li {
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        i {
          float: right;
          margin: 14px 5px 0;
          cursor: pointer;
        }
        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
    .no-bank-tips {
      height: 40px;
      line-height: 40px;
      color: #888;
      text-align: center;
    }
  }
  .edit-part {
    float: left;
    width: calc(100% - 300px);
    padding: 30px 60px;
    height: 100%;
    position: relative;
    background: #eeeeee;
    overflow-y: auto;
    .el-tabs {
      max-width: 1000px;
      margin: 0 auto;
    }
    .el-tabs__new-tab {
      color: #ff552e;
      background-color: #fff;
      height: 30px;
      width: 30px;
      line-height: 30px;
      margin: 6px 0 0 0;
      border-color: #f6c2ba;
      font-size: 16px;
    }
    .edit-title {
      padding: 20px 90px;
      margin-bottom: 15px;
      font-style: auto;
      &:hover,
      &.active {
        background-color: #f0f0f0;
      }
      .ql-editor {
        border: 0;
        text-align: center;
        font-size: 24px;
        color: #333;
      }
    }
    .edit-subtitle {
      padding: 20px 90px;
      margin-bottom: 20px;
      &:hover,
      &.active {
        background-color: #f0f0f0;
      }
      .ql-editor {
        border: 0;
        font-size: 14px;
        color: #666;
        overflow: auto;
      }
    }
    .edit-title,
    .edit-subtitle {
      .quill-editor {
        .ql-toolbar {
          border: 0;
          // display: none;
          .ql-formats {
            margin-right: 5px;
            button {
              padding: 1px 3px;
              width: 24px;
              height: 20px;
            }
          }
        }
        &.ql-focus {
          .ql-toolbar {
            display: block;
          }
          .ql-container {
            border: 1px solid #ddd;
          }
        }
        .ql-container {
          border: 1px solid transparent;
          height: 65px;
          overflow: auto;
          &:hover {
            border: 1px solid #ccc;
          }
        }
      }
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__content {
      padding: 100px 0;
      background-color: #fff;
      border: 1px solid #e4e7ed;
      border-top: 0;
    }
    .el-tabs__item {
      background-color: #f9f9f9;
    }
    .el-tabs__item.is-active {
      background-color: #fff;
    }
    .question-editor {
      background-color: #f9f9f9;
      padding: 20px 80px;
      margin-bottom: 25px;
      .el-form-item.typeChanger {
        margin-bottom: 40px;
      }
      .editor-input {
        width: calc(100% - 180px);
        &.is-disabled {
          input {
            background-color: #fff;
            color: #999;
          }
        }
        input {
          border-color: #ddd;
        }
      }
      .editor-checkbox {
        .editor-input {
          width: calc(100% - 250px);
        }
        .quill-editor {
          width: calc(100% - 250px);
        }
        .addOptionBtn {
          width: calc(100% - 330px);
        }
      }
      .requiredCheck {
        margin-left: 15px;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
      .addOptionBtn {
        height: 40px;
        line-height: 40px;
        text-align: left;
        color: #999;
        cursor: pointer;
        width: calc(100% - 260px);
        border: 1px dashed #ddd;
        margin: 0 0 10px 80px;
        padding: 0 15px;
        background-color: #f5f5f5;
      }
      .edit-settings {
        overflow: hidden;
        padding: 0 30px;
        .el-form-item {
          float: left;
        }
      }
      .customInput {
        .el-form-item__content {
          margin-left: 0px !important;
        }
        .el-input {
          width: 150px;
        }
      }
      .maxSelectInput {
        width: 90px;
        margin-right: 30px;
      }
      .starRangeInput {
        width: 120px;
        margin-right: 30px;
      }
      .edit-btns {
        margin-top: 10px;
        text-align: center;
        .el-button + .el-button {
          margin-left: 30px;
        }
      }
      .addOtherBtn {
        margin-left: 25px;
      }
      .matrixPart {
        width: 42%;
        float: left;
        margin-right: 2.5%;
        text-align: center;
      }
      .addMatrixOptionBtn {
        width: calc(100% - 80px) !important;
      }
      .matrix-input {
        width: calc(100% - 22px);
      }
      .matrix-tips {
        font-size: 16px;
        margin-bottom: 10px;
        color: #333;
      }
      .quill-editor {
        width: calc(100% - 180px);
        float: left;
        line-height: 2;
        .ql-toolbar {
          padding: 0 8px;
          border-radius: 4px 4px 0 0;
          position: absolute;
          top: -29px;
          z-index: 9;
          background-color: #fff;
          border-color: #ddd;
          .ql-formats {
            margin-right: 5px;
            button {
              padding: 1px 3px;
              width: 24px;
              height: 20px;
            }
          }
        }
        .ql-container {
          background-color: #fff;
          border-radius: 0 4px 4px 4px;
          border: 1px solid #ddd;
        }
      }
    }
    .question-viewer {
      padding: 20px 100px;
      margin-bottom: 25px;
      position: relative;
      min-height: 200px;
      img {
        max-width: 100%;
      }
      .el-radio {
        vertical-align: top;
        .el-radio__label {
          width: 90%;
          display: inline-block;
          white-space: pre-line;
          word-wrap: break-word;
          vertical-align: text-top;
        }
        &.starRadio {
          .el-radio__label {
            width: auto;
            vertical-align: middle;
          }
        }
      }
      .el-checkbox {
        .el-checkbox__label {
          width: 90%;
          white-space: pre-line;
          vertical-align: top;
        }
      }
      .el-radio-group:not(.starRadios) {
        width: 100%;
      }
      .starRadios {
        overflow: hidden;
      }
      .starText {
        margin: 0 15px;
        float: left;
        line-height: 24px;
      }
      .starRadio {
        float: left;
        line-height: 24px;
      }
      .el-checkbox,
      .el-radio:not(.starRadio) {
        margin-bottom: 20px;
        margin-right: 0;
        &.row-1 {
          width: 100%;
        }
        &.row-2 {
          width: 50%;
        }
        &.row-3 {
          width: 33.3%;
        }
        &.row-4 {
          width: 25%;
        }
        &.row-5 {
          width: 20%;
        }
        &.row-6 {
          width: 16.6%;
        }
        &.row-7 {
          width: 14.2%;
        }
        &.row-8 {
          width: 12.5%;
        }
        &.row-9 {
          width: 11.1%;
        }
        &.row-10 {
          width: 10%;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
      .el-checkbox + .el-checkbox,
      .el-radio:not(.starRadio) + .el-radio:not(.starRadio) {
        margin-left: 0;
      }
      &:hover {
        background: #f9f9f9;
        border: 1px solid #dddddd;
        .ques-cover {
          .cover-box {
            right: 0;
          }
        }
      }
      .ques-title {
        line-height: 30px;
        display: inline-flex;
      }
      .required-icon {
        color: #ff552e;
        font-size: 20px;
        display: inline-block;
        /*line-height: 24px;*/
        vertical-align: middle;
        margin-left: 5px;
        padding-top: 3px;
      }
      .ques-desc {
        margin-bottom: 20px;
        color: #999;
      }
      .ques-cover {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        cursor: move;
        .cover-box {
          position: absolute;
          right: -80px;
          width: 80px;
          height: 100%;
          background-color: #f9f9f9;
          border-left: 1px solid #eee;
          transition: all 0.2s;
        }
        .cover-tools {
          width: 100%;
          position: absolute;
          top: 50%;
          margin-top: -100px;
          li {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            color: #888;
            text-align: center;
            cursor: pointer;
            background: #eeeeee;
            transition: all 0.2s;
            &:hover {
              background: #eeeeee;
              color: #ff552e;
            }
          }
        }
      }
      .gotoDisp {
        color: #aaa;
        margin-left: 10px;
        font-size: 12px;
      }
      .inputs {
        position: relative;
        .matrix-group {
          position: relative;
          margin-left: 175px;
        }
        .table-scoll {
          overflow-x: auto;
          overflow-y: hidden;
          -webkit-overflow-scrolling: touch;
          zoom: 1;
        }
        .option_title {
          font-weight: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          min-width: 82px;
        }
        .option_choose {
          min-width: 82px;
          text-align: center;
          vertical-align: middle;
          padding-top: 14px;
          line-height: 20px;
        }
        .table_freezed {
          border-spacing: 0;
          margin-left: -175px;
          .el-radio__label,
          .el-checkbox__label {
            display: none;
          }
        }
        .sub_title {
          // width: 25%;
          min-width: 175px;
          width: 175px;
          padding-top: 14px;
          padding-bottom: 20px;
          .subtitle_text {
            // padding-left: 10px;
            line-height: 20px;
            overflow: hidden;
          }
        }
        .matrix_group_mirror {
          position: absolute;
          top: 0px;
          width: 175px;
          min-width: auto;
          border-spacing: 0;
        }
      }
      .matrix-disp {
        text-align: center;
        .matrix-title {
          display: flex;
          word-break: break-all;
          padding-left: 100px;
        }
        .matrix-option {
          flex: 1;
          word-break: break-all;
          min-width: 80px;
        }
        .matrix-content {
          height: 40px;
          line-height: 40px;
        }
        .matrix-subtitle {
          width: 100px;
          text-align: left;
          word-break: break-all;
          float: left;
        }
      }
    }
    .more-setting-btn {
      position: absolute;
      width: 120px;
      left: 50%;
      margin-left: -60px;
      top: -24px;
      background-color: #f9f9f9;
    }
    .backgroundGray {
      background-color: #f9f9f9;
      border: 0;
      .el-collapse-item {
        margin-top: 20px;
      }
      .el-collapse-item__header {
        height: 25px;
        border-bottom: 0;
        background-color: #f9f9f9;
      }
    }
    .el-collapse-item__content {
      padding-bottom: 0px;
    }
    .el-icon-arrow-right:before {
      content: "";
    }
    .advanced-setting-title {
      text-align: center;
      border-top: 1px solid #ddd;
      color: #666;
      position: relative;
      height: 100%;
    }
    .bottom10 {
      margin-bottom: 10px;
    }
    .quoteOption {
      display: block;
    }
    .addOtherButton {
      margin-left: 80px;
    }
    .ql-tooltip {
      z-index: 9;
    }
    .answerActive {
      color: #f56c6c;
      margin-left: 10px;
      font-size: 12px;
      display: inline-block;
    }
  }
  .changeEditType {
    strong {
      color: #f0614e;
    }
  }
  .wj-icon {
    width: 15px;
    height: 15px;
    display: inline-block;
    vertical-align: sub;
    background-image: url(../assets/sprite@3x.png);
    background-size: 525px 875px;
    &.radio-icon {
      background-position: -1px -340px;
    }
    &.checkbox-icon {
      background-position: -36px -340px;
    }
    &.textarea-icon {
      background-position: -71px -340px;
    }
    &.star-icon {
      background-position: -106px -340px;
    }
    &.select-icon {
      background-position: -141px -340px;
    }
    &.sort-icon {
      background-position: -176px -340px;
    }
    &.description-icon {
      background-position: -421px -340px;
    }
    &.upload-icon {
      background-position: -386px -340px;
    }
    &.matrixRadio-icon {
      background-position: -211px -340px;
    }
    &.matrixCheckbox-icon {
      background-position: -246px -340px;
    }
    &.matrixStar-icon {
      background-position: -281px -340px;
    }
    &.chainedSelects-icon {
      background-position: -316px -340px;
    }
    &.textMultiple-icon {
      background-position: -351px -340px;
    }
    &.date-icon {
      background-position: -456px -340px;
    }
    &.region-icon {
      height: 16px;
      background-position: -487px -339px;
    }
  }
  @media screen and (max-width: 1280px) {
    .edit-part {
      padding: 20px;
    }
  }

  .el-main {
    .question-viewer {
      margin-bottom: 0 !important;
    }
    .edit-subtitle {
      padding: 10px 90px;
    }
  }
  .errorTooltip {
    input {
      border-color: #f56c6c;
    }
  }
  .el-slider__bar {
    background-color: transparent;
  }
  .textMultiple {
    border: 0;
    border-bottom: 1px solid #000;
    background-color: transparent;
  }
  .bank-title {
    float: left;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 20px;
  }
  .bank-operate {
    padding: 0;
    line-height: 40px;
    height: 40px;
    text-align: center;
    min-width: 110px;
  }
  .bank-detail-title,
  .bank-detail-opt {
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .bank-detail-opt.inline {
    max-width: 60px;
    display: inline-block;
    margin-right: 10px;
  }
  .linkDialog .el-form-item__label {
    text-align: left;
  }
  .corpDialog .el-form-item__content {
    width: 100%;
  }
  .edit-part .end-page .quill-editor .ql-container,
  .edit-part .end-page .quill-editor .ql-container {
    border: 1px solid transparent;
    height: 320px;
    overflow: auto;
  }
  .edit-part .edit-subtitle.end-page .ql-editor {
    text-align: center;
    p {
      text-align: center;
    }
  }
  .collect-radio-group {
    margin-left: 40px;
    .el-radio {
      width: 100%;
      margin-bottom: 20px;
      margin-left: 0;
    }
  }
  .add-collect {
    color: #ff552e;
    display: block;
    margin-left: 40px;
    span {
      margin-right: 14px;
    }
  }
  .collapse-add-collect {
    height: 40px;
    line-height: 40px;
    color: #ff552e;
    display: inline-block;
    span {
      margin-right: 14px;
    }
  }
  .el-collapse-item__header {
    position: relative;
    .tooltip-icon {
      position: absolute;
      right: 15px;
      display: inline-block;
      bottom: 6px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .el-tooltip-icon:first-child {
    display: none;
  }
  .content-info:hover {
    color: #ff552e;
  }
  .collect-page .el-collapse-item__arrow {
    display: none;
  }
  .wj-collect-icon {
    background-size: contain;
    display: inline-block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 4px;
    right: 5px;
    margin-right: 3px;
    &.wj-file-icon {
      background-image: url("../assets/wj-file-icon.png");
    }
    &.wj-like-icon {
      background-image: url("../assets/wj-like-icon.png");
    }
    &.wj-sys-icon {
      background-image: url("../assets/wj-sys-icon.png");
    }
  }
  .dir-name-input input {
    height: 30px;
    line-height: 14px;
    font-size: 14px;
    padding: 8px;
  }

  .el-tooltip__popper[x-placement^="right"] .popper__arrow {
    border-right-color: #ebeef5;
  }
  .el-tooltip__popper[x-placement^="right"] .popper__arrow::after {
    border-right-color: #ebeef5;
  }
  .el-tooltip__popper.is-light {
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow {
    border-right-color: #ebeef5;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/templateEdit.vue